const NoDataMessage = ({
  absorption,
  type,
}: {
  absorption: number;
  type?: string;
}) => {
  const RenderData = (type: string) => {
    switch (type) {
      case 'b':
        return '임차인이 없으며 전부를 소유자가 점유 사용합니다.';
      case 'c':
        return '최근 실거래 이력이 없습니다';
      case 'd':
        return '최근 10년 실거래 이력이 없습니다.';
      default:
        return '해당 내용 없음';
    }
  };
  return (
    <tr>
      <td
        colSpan={absorption}
        style={{
          textAlign: 'center',
          height: '90px',
          background: '#f7f8f9',
          fontFamily: 'Spoqa Han Sans Neo',
          fontWeight: 500,
          fontSize: '18px',
        }}
      >
        {RenderData(type ?? '')}
      </td>
    </tr>
  );
};

export default NoDataMessage;

export const DetailNoDataColumn = ({
  absorption,
  type,
}: {
  absorption: number;
  type?: string;
}) => {
  return (
    <tr>
      <td
        colSpan={absorption}
        style={{
          textAlign: 'center',
          height: '40px',
          borderBottom: '1px solid #E1E2E4',
          fontFamily: 'Spoqa Han Sans Neo',
          fontWeight: 500,
          fontSize: '14px',
          color: '#222',
        }}
      >
        {type ? type : '검색 결과가 없습니다.'}
      </td>
    </tr>
  );
};
